"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Meeting = exports.MEETING_DEFAULT_DETAILS = void 0;
var account_1 = require("../../account");
var billing_1 = require("../../billing");
var comment_1 = require("../../comment");
var school_1 = require("../../school");
var classroom_1 = require("../classroom");
var user_service_1 = require("../user-service");
var enums_1 = require("./enums");
var meeting_participant_1 = require("./meeting-participant");
var properties = ['id', 'readonly', 'author_id', 'author', 'type', 'category_id', 'category', 'slug', 'title', 'tokbox_session', 'cover_id', 'cover', 'description', 'language_id', 'language', 'subject_id', 'subject', 'level_id', 'level', 'level_other_name', 'begin', 'begin_at', 'end_at', 'duration', 'classroom_id', 'classroom', 'created_at', 'published_at', 'archived_at', 'started_at', 'finished_at', 'engine', 'access', 'charging', 'options', 'participants_limit', 'participants_count', 'reservations_count', 'keywords', 'status', 'audio_video_state', 'billing_status', 'session_id', 'school_id', 'school', 'price_tier', 'priceTier', 'comments', 'participants', 'stats', 'visit_info', 'finance_info', 'homework_due_at', 'can', 'is', 'has', 'params', 'user_service_id', 'user_service', 'user_service_contract_id', 'user_service_contract', 'meeting_group_id', 'purl', 'hidden', 'readonly', 'tenant'];
var dateProperties = ['begin_at', 'end_at', 'published_at', 'archived_at', 'started_at', 'finished_at', 'created_at', 'homework_due_at'];
exports.MEETING_DEFAULT_DETAILS = ['id', 'slug', 'type', 'title', 'subject', 'level', 'language', 'author:sm', 'cover', 'cover_id', 'description', 'keywords', 'visit_info', 'can', 'is', 'has', 'begin', 'begin_at', 'end_at', 'duration', 'created_at', 'published_at', 'finished_at', 'options', 'status'];
/** Митинг */
var Meeting = /** @class */function () {
  function Meeting(values) {
    if (values === void 0) {
      values = {};
    }
    /** Название */
    this.title = '';
    /** Сессия tokbox */
    this.tokbox_session = '';
    /** Описание */
    this.description = '';
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    var instance = this;
    if (!values) {
      return instance;
    }
    properties.forEach(function (p) {
      if (p in values) {
        instance[p] = values[p];
      }
    });
    this.is_draft = this.type === enums_1.MeetingTypeEnum.not_defined || this.begin === enums_1.MeetingBeginEnum.not_defined || this.charging === billing_1.BillingMeetingChargingEnum.not_defined;
    if ('author' in values) {
      instance.author = new account_1.User(values.author);
    }
    instance.participants = (values.participants || []).map(function (p) {
      return new meeting_participant_1.MeetingParticipant(p);
    });
    if ('classroom' in values) {
      instance.classroom = new classroom_1.Classroom(values.classroom);
    }
    if ('school' in values) {
      instance.school = new school_1.CSchool(values.school);
    }
    if ('category' in values) {
      instance.category = new user_service_1.UserServiceCategory(values.category);
    }
    if ('user_service' in values) {
      instance.user_service = new user_service_1.UserService(values.user_service);
    }
    if ('user_service_contract' in values) {
      instance.user_service_contract = new user_service_1.UserServiceContract(values.user_service_contract);
    }
    if ('comments' in values) {
      instance.comments = {
        total: values.comments.total,
        first: (values.comments.first || []).map(function (c) {
          return new comment_1.Comment(c);
        }),
        last: (values.comments.last || []).map(function (c) {
          return new comment_1.Comment(c);
        })
      };
    }
    // преобразование дат
    dateProperties.forEach(function (p) {
      if (p in instance && instance[p]) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        instance[p] = new Date(instance[p]);
      }
    });
  }
  return Meeting;
}();
exports.Meeting = Meeting;
